var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-energetic-blue"},[_c('h4',{staticClass:"text-left font-extrabold p-4 text-white m-0"},[_vm._v("\n    "+_vm._s(_vm.headerText)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }